import { useEffect, useState } from "react";
import './course.css'
export default function Coursedata() {
    const [categories, setCategories] = useState([]);
    const [newCategory, setNewCategory] = useState('');
    const [newCourse, setNewCourse] = useState('');
    const [editingCourse, setEditingCourse] = useState(null); // مشخص می‌کند کدام دوره در حال ویرایش است
    const [newCourseName, setNewCourseName] = useState('');   // نام جدید دوره



    useEffect(() => {
        fetch('http://185.164.73.170:5001/api/doreha')
            .then(res => res.json())
            .then(data => setCategories(data.categories));
    }, []);

    const addCourse = () => {
        if (!newCategory) return alert('Please fill in all fields.');

        fetch('http://185.164.73.170:5001/api/doreha', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ category: newCategory, course: newCourse }),
        })
            .then(res => res.json())
            .then(data => {
                setCategories(data.categories);
                setNewCategory('');
                setNewCourse('');
            });
    };

    const deleteCourse = (category, course) => {
        fetch('http://185.164.73.170:5001/api/doreha', {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ category, course }),
        })
            .then(res => res.json())
            .then(data => setCategories(data.categories));
    };

    const deleteCategory = (categoryName) => {
        fetch('http://185.164.73.170:5001/api/doreha/category', {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ category: categoryName }),
        })
            .then(res => res.json())
            .then(data => setCategories(data.categories || []))
            .catch(err => console.error('Failed to delete category:', err));
    };

    const editCategory = (oldCategory, newCategory) => {
        fetch('http://185.164.73.170:5001/api/doreha/category', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ oldCategory, newCategory }),
        })
            .then(res => res.json())
            .then(data => setCategories(data.categories || []))
            .catch(err => console.error('Failed to edit category:', err));
    };

    const editCourse = (categoryName, oldCourseName, newCourseName) => {
        fetch('http://185.164.73.170:5001/api/doreha/course', {
            method: 'PUT',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ category: categoryName, oldCourse: oldCourseName, newCourse: newCourseName }),
        })
            .then(res => res.json())
            .then(data => setCategories(data.categories || []))
            .catch(err => console.error('Failed to edit course:', err));
    };

    return (
        <div className="coursedatapage">
            <div className="coursedatahead">
                <h1>دوره ها</h1>
                <div className="form">
                    <input
                        type="text"
                        placeholder="اسم دوره"
                        value={newCategory}
                        onChange={(e) => setNewCategory(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="اسم دسته بندی"
                        value={newCourse}
                        onChange={(e) => setNewCourse(e.target.value)}
                    />
                    <button onClick={addCourse}>ثبت</button>
                </div>
            </div>
            <div className="coursedata">
            {categories && categories.map((cat) => (
                <div key={cat.name} className="coursecategory">
                    <h2>
                        {cat.name}{' '}
                        <button onClick={() => deleteCategory(cat.name)}>خذف</button>
                    </h2>
                    <ul>
                        {cat.courses.map((course) => (
                            <li key={course}>
                                {editingCourse?.name === course && editingCourse?.category === cat.name ? (
                                    <div>
                                        <input
                                            type="text"
                                            value={newCourseName}
                                            onChange={(e) => setNewCourseName(e.target.value)}
                                            placeholder="متن جدید دوره"
                                        />
                                        <button onClick={() => editCourse(cat.name, course, newCourseName)}>ذخیره</button>
                                        <button onClick={() => setEditingCourse(null)}>انصراف</button>
                                    </div>
                                ) : (
                                    <>
                                        <p>{course}{' '}</p>
                                        <div>
                                        <button style={{backgroundColor: 'green'}} onClick={() => setEditingCourse({ name: course, category: cat.name }, setNewCourseName(course))}>
                                            ویرایش
                                        </button>
                                        <button onClick={() => deleteCourse(cat.name, course)}>حذف</button>
                                        </div>
                                    </>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
            </div>


        </div>
    );
}